module.exports = __webpack_public_path__ + "static/media/tml.b2909ea3.svg";